/**
 * ARIA-tabs roving navigation: returns the next focusable index for a
 * key press, or `null` if the key isn't a navigation key. Wraps at both
 * ends so `ArrowRight` (horizontal) / `ArrowDown` (vertical) on the last
 * item lands on the first.
 *
 * Used by {@link PreferencesTopNav} (horizontal) and
 * {@link PreferencesSideNav} (vertical) for keyboard navigation.
 *
 * @param key Native `KeyboardEvent.key` value, e.g. `"ArrowLeft"`, `"Home"`
 * @param current Currently active index
 * @param total Total item count
 * @param orientation Determines which arrow keys are honored
 */
export function nextRovingIndex(
  key: string,
  current: number,
  total: number,
  orientation: 'horizontal' | 'vertical',
): number | null {
  const prevKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp'
  const nextKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown'
  switch (key) {
    case prevKey:
      return (current - 1 + total) % total
    case nextKey:
      return (current + 1) % total
    case 'Home':
      return 0
    case 'End':
      return total - 1
    default:
      return null
  }
}
